import React from 'react';
import { Row, Col, Label, Button } from "reactstrap";
import { observer, inject } from 'mobx-react';
import FormInput from '../../../../comum/components/FormInput';
import FormInputNumber from '../../../../comum/components/FormInputNumber';
import FormInputCNPJCPF from '../../../../comum/components/FormInputCNPJCPF';
import FormInputCurrency from '../../../../comum/components/FormInputCurrency';
import { IconeDelete, IconeSetaSubir, IconeSetaDescer } from '../../../../comum/components/Icones';
import FormSelect from '../../../../comum/components/FormSelect';
import CheckboxField from '../../../../comum/components/CheckboxField';
import FormDatePicker from '../../../../comum/components/FormDatePicker'
import CardNotaFiscalStore from '../stores/CardNotaFiscalStore';
import CardNotaFiscalContainers from './CardNotaFistalContainers';
import CardNotaFiscalNCM from './CardNotaFiscalNCM';
import {quantidadeMinChar44} from "../../../../../utils/validadores";
import _ from "lodash";
import moment from "moment/moment";

@inject("store")
@observer
export default class CardNotaFiscal extends React.Component {
    constructor(props) {
        super(props);
        this.appStore = this.props.store.appStore;

        this.controller = new CardNotaFiscalStore();
        this.handleClickBagagem = this.handleClickBagagem.bind(this);
        this.handleClickBitrem = this.handleClickBitrem.bind(this);
        this.handleCollapse = this.handleCollapse.bind(this);
        this.listaContainers = this.listaContainers.bind(this);
        
        this.state = {
            atualizado: true
        }
    }

     componentDidMount() {
        this.controller.carregarPaises();
        this.controller.carregarTransportadorasNotaFiscal();
        if(_.get(this.props.ntFiscal,'Nf.CdPaisDest')){
            this.controller.carregarUFs(_.get(this.props.ntFiscal,'Nf.CdPaisDest'));
        }

        if(_.get(this.props.ntFiscal,'Nf.FlagBagagem')=='V' || _.get(this.props.ntFiscal,'Nf.FlagBitrem')=='S'){
            this.controller.flagAtivo = true;
        }

        if(this.props.isEditar){
            this.props.carregarContainersSelecionados();
            const pais = _.get(this.props.ntFiscal, `Nf.CdPaisDest`);
            this.controller.setPais(pais, this.props.dado, this.props.setDado);
            
            const CNPJEmissor = _.get(this.props.ntFiscal, `Nf.Cnpjs`);
            this.controller.setCNPJEmissor(CNPJEmissor, this.props.dado, this.props.setDadoDireto);
            const CNPJDest = _.get(this.props.ntFiscal, `Nf.CnpjDest`);
            this.controller.setCNPJDestinatarioSemPensar(CNPJDest, this.props.dado, this.props.setDadoDireto);
        }
        this.props.setStatusSalvo(false);
        this.props.agendamentoController.validarContainerBookingNotas();
    }

    handleRemover = () => this.props.remover(this.props.index);

    handleRemoverContainer = (index, posContainer) => {
        this.props.removerContainer(index, posContainer);
    }

    handleRemoverNCM = (index, pos) => {
        this.props.removerNCM(index, pos);
    }

    handleMudaCnpjEmissor = (cnpj) => {
        this.controller.setCNPJEmissor(cnpj, this.props.dado, this.props.setDadoDireto);
    };

    handleMudaCnpjDestinatario = (cnpj) => {
        this.controller.setCNPJDestinatario(cnpj, this.props.dado, this.props.setDadoDireto);
    };

    alertaInfoContainer = () => {
        let alerta = ( <div />);
        if ( this.props.agendamentoController.exibeAlertaBookingNotas != null && 
            this.props.agendamentoController.exibeAlertaBookingNotas)       
        {
            alerta = (
                <div className="card-atencao narrow float">
                    <div className="d-flex w-100 justify-content-between align-items-center">
                        <div className="card-atencao--title"> 
                            Atenção! 
                        </div>                        
                    </div>
                    <div className={this.classLabel}>
                        <label>
                            {this.props.agendamentoController.alertaBookingNotas != null 
                            && this.props.agendamentoController.alertaBookingNotas.length > 0 
                            && this.props.agendamentoController.alertaBookingNotas.map(alerta =>
                                <div>{alerta}</div>
                            )}
                        </label>
                    </div>
                </div>
            )
        }
        return alerta;  
    }

    listaContainers() {
        return <div>
                <Row>
                    <Col>
                        <h2>Containers</h2>
                    </Col>
                </Row>
                <div className="card-branco area-form">
                    <Row>
                        <Col xl={12} lg={12}>
                            {this.alertaInfoContainer()}
                        </Col>
                    </Row>
                    {   
                        this.props.ntFiscal.ListaCntr && this.props.ntFiscal.ListaCntr.map((container, pos) => (
                            <CardNotaFiscalContainers key={pos}
                                index={pos}
                                notaIndex = {this.props.index}
                                container={ container }
                                removeContainer = {this.props.removerContainer}
                                controller={ this.controller }
                                dado={ `${this.props.dado}.ListaCntr[${pos}]` }
                                notaFiscal={this.props.ntFiscal}
                                bookings={this.props.bookings}
                                setDado={ this.props.setDado }
                                setDadoDireto={this.props.setDadoDireto}
                                setCamposContainer={this.props.setCamposContainer}
                                listaContainersSelect={this.props.listaContainersSelect}
                                atualizaDados={this.props.atualizaDados}
                                containersSelecionados={this.props.containersSelecionados} //Mobx reclamando por estar "out of bounds"
                                atualizaContainers={this.props.atualizaContainers} 
                                validarContainerBookingNotas = {this.props.agendamentoController.validarContainerBookingNotas}
                            />
                        ))
                    }
                    <div className="area-btn-adicionar">
                        <div className="justify-content-end">
                            <Label className="btn-primary" onClick={ () => this.props.adicionarNovoContainer(this.props.index)}>Adicionar</Label>
                        </div>
                    </div>
                </div>
            </div>
    }

    listaNCMs() {
        return <div>
                <Row>
                    <Col>
                        <h2>NCM</h2>
                    </Col>
                </Row>
                {
                    this.appStore.isMobile()
                    ? <div>
                        {
                            this.props.ntFiscal.ListaItem && this.props.ntFiscal.ListaItem.map((ncm, pos) => (
                                <div key={pos} className="card-branco area-form" >
                                    <CardNotaFiscalNCM
                                        index={pos}
                                        ncm={ ncm }
                                        notaIndex = {this.props.index}
                                        removeNCM = {this.props.removerNCM}
                                        controller={ this.controller }
                                        dado={ `${this.props.dado}.ListaItem[${pos}]` }
                                        este={ _.get(this.props.ntFiscal, `ListaItem[${pos}]`) }
                                        setDado={ this.props.setDado } />
                                </div>
                            ))
                        }
                        <div className="area-btn-adicionar">
                            <div className="justify-content-end">
                                <Label className="btn-primary" onClick={ () => this.props.adicionarNovoNCM(this.props.index) }>Adicionar</Label>
                            </div>
                        </div>
                    </div>
                    : <div className="card-branco area-form">
                        <Row>
                            <Col sm={12} md={3}>
                                <Label>NCM</Label>
                            </Col>
                            <Col sm={12} md={2}>
                                <Label>Quantidade</Label>
                            </Col>
                            <Col sm={12} md={2}>
                                <Label>Valor Item</Label>
                            </Col>
                            <Col sm={12} md={2}>
                                <Label>Peso Item</Label>
                            </Col>
                            <Col sm={12} md={3}>
                                <Label>CFOP</Label>
                            </Col>
                        </Row>
                        {
                            this.props.ntFiscal.ListaItem && this.props.ntFiscal.ListaItem.map((ncm, pos) => (
                                <CardNotaFiscalNCM key={pos}
                                    index={pos}
                                    ncm={ncm}
                                    notaIndex = {this.props.index}
                                    removeNCM = {this.props.removerNCM}
                                    controller={ this.controller }
                                    dado={ `${this.props.dado}.ListaItem[${pos}]` }
                                    este={ _.get(this.props.ntFiscal, `ListaItem[${pos}]`) }
                                    setDado={ this.props.setDado } />
                            ))
                        }
                        <div className="area-btn-adicionar">
                            <div className="justify-content-end">
                                <Label className="btn-primary" onClick={ () => this.props.adicionarNovoNCM(this.props.index) }>Adicionar</Label>
                            </div>
                        </div>
                    </div>
                }
            </div>
    }

    handleClickBitrem = (event) => {
        if (event) this.props.setDado(`${this.props.dado}.Nf.FlagBitrem`, {value: 'S'});
        else this.props.setDado(`${this.props.dado}.Nf.FlagBitrem`, {value: 'N'});
    };

    handleClickBagagem = (event) =>  {
        
        if (event) 
        {
            this.props.setDado(`${this.props.dado}.Nf.FlagBagagem`, {value: 'V'});
            this.props.setDadoDireto(`${this.props.dado}.Nf.SerieNotaTransp`, null);
            this.props.setDadoDireto(`${this.props.dado}.Nf.ChaveNfe`, null);
            this.props.setDadoDireto(`${this.props.dado}.Nf.TranspId`, null);
            this.props.setDadoDireto(`${this.props.dado}.Nf.NumNotaTransp`, null);
            this.props.setDadoDireto(`${this.props.dado}.Nf.QtdTotal`, null);
            this.props.setDadoDireto(`${this.props.dado}.Nf.PesoTotal`, null);
            this.props.setDadoDireto(`${this.props.dado}.Nf.ValTotal`, null);
            this.props.setDadoDireto(`${this.props.dado}.Nf.Cnpjs`, null);
            this.props.setDadoDireto(`${this.props.dado}.Nf.RazaoSocialEmissor`, null);
            this.props.setDadoDireto(`${this.props.dado}.Nf.CnpjDest`, null);
            this.props.setDadoDireto(`${this.props.dado}.Nf.RazaoSocialDest`, null);
            this.props.setDadoDireto(`${this.props.dado}.Nf.InscrEstadDest`, null);
            this.props.setDadoDireto(`${this.props.dado}.Nf.CdPaisDest`, null);
            this.props.setDadoDireto(`${this.props.dado}.Nf.CdUnidadeFedDest`, null);
            this.props.setDadoDireto(`${this.props.dado}.Nf.NomeCidadeDest`, null);

            this.controller.flagAtivo = true;
            this.props.setBagagemFlag(true);
            this.controller.atualizaBagagem = false;
            setTimeout(function() {
                this.controller.atualizaBagagem = true;
            }.bind(this), 1);
        }
        else 
        {    
            this.props.setDado(`${this.props.dado}.Nf.FlagBagagem`, {value: 'F'});
            this.controller.flagAtivo = false;
            this.props.setBagagemFlag(false);
        }
    };

    excluiDadosNota = () => {
        setTimeout(() => {
            this.setState({atualizado : true}); 
        }, 1);
        return <div />
    }
    
    handleCollapse = () => {
        this.setState({atualizado : false})
        this.props.collapseNotaFiscal(!this.props.ntFiscal.collapsed, this.props.index);
    };

     listaNotaFiscalForm () {
        return (
            <div className="card-expansivel">
                <div className={ this.props.ntFiscal.collapsed ? "card-branco" : "card-branco escondido" } >
                    <Row className="titulo-booking align-items-center">
                        <Col >
                            <h2 className="p-0">
                                { _.get(this.props.ntFiscal.Nf, `NumNotaTransp`) ? _.get(this.props.ntFiscal.Nf, `NumNotaTransp`).toUpperCase() : "" }
                                { _.has(this.props.booking, `Status`) &&
                                    <Label className="situacao-btn em-espera">{ _.get(this.props.booking, `Status`) }</Label>
                                }
                            </h2>
                        </Col>
                        <Col>
                            <div className="float-right align-items-center">
                                {/* <IconeCopiar tamanho="2x" /> */}
                                <IconeDelete tamanho="2x" onClick={ this.handleRemover } />
                                <Button onClick={this.handleCollapse} outline className="collapseItem" active={ false }>
                                        { this.props.ntFiscal.collapsed ? <IconeSetaDescer tamanho="lg" /> : <IconeSetaSubir tamanho="lg" />  }
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </div>
                <div className={ this.props.ntFiscal.collapsed ? "detalhes-ativo escondido" : "detalhes-ativo" }>
                    <div className="card-branco titulo">
                        <Row className="titulo-booking align-items-center">
                            <Col onClick={() => console.log(this.props.ntFiscal)}>
                                <h2 className="p-0"> { _.get(this.props.ntFiscal, `NumNotaTransp`) ? _.get(this.props.ntFiscal, `NumNotaTransp`).toUpperCase() : "" } {/* <IconeEditar /> */} </h2>
                            </Col>
                            <Col>
                                <div className="float-right align-items-center">
                                    {/* <IconeCopiar tamanho="2x" /> */}
                                    <IconeDelete tamanho="2x" onClick={ this.handleRemover } />
                                    <Button onClick={this.handleCollapse} outline className="collapseItem" active={ true }>
                                        { this.props.ntFiscal.collapsed ? <IconeSetaDescer tamanho="lg" /> : <IconeSetaSubir tamanho="lg" /> }
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className="detalhes">
                        <Row  className="mb-0">
                            <Col  className="mb-0">
                                <h2 >Nota</h2>
                            </Col>
                        </Row>
                        <Row className="d-flex justify-content-start align-middle mr-0 mb-1" >
                            {this.props.isRIG && <CheckboxField  sm={12} md={3} noTitle={true}
                                            text="Bagagem" ativo={this.controller.flagAtivo}
                                            onClick={ (event) => this.handleClickBagagem(event) }
                            />}
                            {this.props.isSSA && <CheckboxField sm={12} md={3} noTitle={true}
                                text="Bi-trem" ativo={this.controller.flagAtivo}
                                onClick={ (event) => this.handleClickBitrem(event) }
                            />}
                        </Row>
                        <Row className="area-form">
                            
                            <FormInput titulo={this.props.isRIG && this.controller.flagAtivo ? "Número DUE" : "Nota"} sm={12} md={3}
                                objeto={ this.props.ntFiscal }
                                dado={ `Nf.NumNotaTransp` }
                                limiteMaximo={30}
                                onChange={ (event) => this.props.setDado(`${this.props.dado}.Nf.NumNotaTransp`, event) }
                                //alerta={ (this.props.salvo && !_.get(this.props.ntFiscal, "Nf.NumNotaTransp")) ? "Campo obrigatório" : "" } 
                            />
                            { this.controller.atualizaBagagem &&
                            <FormInput titulo="Série" sm={12} md={3}
                                objeto={ this.props.ntFiscal }
                                dado={ `Nf.SerieNotaTransp` }
                                limiteMaximo={5}
                                onChange={ (event) => this.props.setDado(`${this.props.dado}.Nf.SerieNotaTransp`, event) }
                                //alerta={ (this.props.salvo && !_.get(this.props.ntFiscal, "Nf.SerieNotaTransp") && !this.controller.flagAtivo) ? "Campo obrigatório" : "" }
                                bloqueado={(this.props.isRIG) ? this.controller.flagAtivo : false} 
                            /> }
                            { this.controller.atualizaBagagem &&
                            <FormInput titulo="Chave NFe" sm={12} md={3}
                                objeto={ this.props.ntFiscal }
                                dado={ `Nf.ChaveNfe` }
                                limiteMaximo={44}
                                limiteMinimo={44}
                                validador={quantidadeMinChar44}
                                validacaoStore={this.props.agendamentoController.setValidacao}
                                onChange={ (event) => this.props.setDado(`${this.props.dado}.Nf.ChaveNfe`, event) }
                                //alerta={ (this.props.salvo && !_.get(this.props.ntFiscal, "Nf.ChaveNfe") && !this.controller.flagAtivo) ? "Campo obrigatório" : "" }
                                bloqueado={(this.props.isRIG) ? this.controller.flagAtivo : false} 
                            /> }
                            { this.props.isSSA && 
                            <FormInputCurrency titulo="Valor IPI" sm={12} md={3} type="number"
                                objeto={ this.props.ntFiscal }
                                dado={ `Nf.ValIpi` }
                                onChange={ (event) => this.props.setDado(`${this.props.dado}.Nf.ValIpi`, event) }
                                //alerta={ (this.props.salvo && this.controller.verificaCampoVazioNF(_.get(this.props.ntFiscal, "Nf.ValIpi")) && !this.controller.flagAtivo) ? "Campo obrigatório" : "" } 
                            /> }
                            { this.props.isSSA && 
                            <FormInputCurrency titulo="Valor ICMS" sm={12} md={3} type="number"
                                objeto={ this.props.ntFiscal }
                                dado={ `Nf.ValIcms` }
                                onChange={ (event) => this.props.setDado(`${this.props.dado}.Nf.ValIcms`, event) }
                                //alerta={ (this.props.salvo && this.controller.verificaCampoVazioNF(_.get(this.props.ntFiscal, "Nf.ValIcms"))) ? "Campo obrigatório" : "" } 
                            /> }
                            {this.controller.atualizaBagagem &&
                            <FormInputNumber titulo="Quantidade Total" sm={12} md={3} type="number"
                                objeto={ this.props.ntFiscal }
                                dado={ `Nf.QtdTotal` }
                                onChange={ (event) => this.props.setDado(`${this.props.dado}.Nf.QtdTotal`, event) }
                                //alerta={ (this.props.salvo && this.controller.verificaCampoVazioNF(_.get(this.props.ntFiscal, "Nf.QtdTotal"))) ? "Campo obrigatório" : "" } 
                                />
                            }
                            {this.controller.atualizaBagagem &&
                            <FormInputCurrency titulo="Peso Total" sm={12} md={3} type="number"
                                objeto={ this.props.ntFiscal }
                                dado={ `Nf.PesoTotal` }
                                formataMoeda={true}
                                separadorMilesimo=","
                                separadorDecimal="."
                                onChange={ (event) => this.props.setDado(`${this.props.dado}.Nf.PesoTotal`, event) }/>
                            }
                            {this.controller.atualizaBagagem &&
                            <FormSelect titulo="Transportadora" sm={12} md={3}
                                itens={this.controller.transportadorasNotaFiscal}
                                objeto={this.props.ntFiscal}
                                dado={"Nf.TranspId"}
                                itensValor="Id" itensLabel="Texto"
                                //alerta={(this.props.salvo && this.controller.verificaCampoVazioNF(_.get(this.props.ntFiscal, "Nf.TranspId"))) ? "Campo obrigatório" : "" }
                                onChange={(event) => this.props.setDado(`${this.props.dado}.Nf.TranspId`, event)} />
                            }
                            <FormDatePicker md={3} sm={12} titulo="Emissão"
                                uniqueId="emissaoData"
                                onChange={ (event) => this.props.setDado(`${this.props.dado}.Nf.DatEmissao`, event)}
                                date={_.get(this.props.ntFiscal, `Nf.DatEmissao`) ? moment(_.get(this.props.ntFiscal, `Nf.DatEmissao`)) : null}
                                //alerta={ (this.props.salvo && !_.get(this.props.ntFiscal, "Nf.DatEmissao")) ? "Campo obrigatório" : "" }
                                />
                            <FormDatePicker md={3} sm={12} titulo="Saída"
                                uniqueId="saidaData"
                                onChange={ (event) => this.props.setDado(`${this.props.dado}.Nf.DatSaidaEmissor`, event) }
                                date={_.get(this.props.ntFiscal, `Nf.DatSaidaEmissor`) ? moment(_.get(this.props.ntFiscal, `Nf.DatSaidaEmissor`)) : null}
                                //alerta={ (this.props.salvo && !_.get(this.props.ntFiscal, "Nf.DatSaidaEmissor")) ? "Campo obrigatório" : "" }
                            />
                            {this.controller.atualizaBagagem &&
                            <FormInputCurrency titulo="Valor Total" sm={12} md={3} type="number"
                                objeto={ this.props.ntFiscal }
                                dado={ `Nf.ValTotal` }
                                formataMoeda={true}
                                separadorMilesimo=","
                                separadorDecimal="."
                                onChange={ (event) => this.props.setDado(`${this.props.dado}.Nf.ValTotal`, event) }
                                //alerta={ (this.props.salvo && this.controller.verificaCampoVazioNF(_.get(this.props.ntFiscal, "Nf.ValTotal"))) ? "Campo obrigatório" : "" } 
                                />
                            }
                            {this.controller.atualizaBagagem &&
                            <FormInputCNPJCPF titulo="CNPJ do Emissor" sm={12} md={3}
                                objeto={ this.props.ntFiscal }
                                dado={ `Nf.Cnpjs` }
                                limiteMaximo={18}
                                labelStatus={_.get(this.props.ntFiscal, "Nf.Cnpjs") ? _.get(this.props.ntFiscal, "Nf.CnpjEmissor_lblNaoExiste"):""}
                                onChange={(event) => this.controller.setCNPJEmissor(event.target.value, this.props.dado, this.props.setDadoDireto)}
                                />
                            }
                            {this.controller.atualizaBagagem && this.controller.atualizarCnpjEmissor && 
                            <FormInput
                                titulo="Razão Social do Emissor" sm={12} md={3}
                                onChange = {() => {}}
                                //alerta={ (this.props.salvo && !_.get(this.props.ntFiscal, "Nf.RazaoSocialEmissor")) ? "Campo obrigatório" : "" }
                                objeto={ this.props.ntFiscal }
                                dado={ `Nf.RazaoSocialEmissor` }
                            />}
                        </Row>
                        <Row>
                            <Col>
                                <h2>Destinatário</h2>
                            </Col>
                        </Row>
                        <Row className="area-form">
                            {this.controller.atualizaBagagem &&
                            <FormInputCNPJCPF titulo="CNPJ do Destinatário" sm={12} md={4}
                                objeto={ this.props.ntFiscal }
                                dado={ `Nf.CnpjDest` }
                                labelStatus={_.get(this.props.ntFiscal, "Nf.CnpjDest") ? _.get(this.props.ntFiscal, "Nf.CnpjDestinatario_lblNaoExiste"):""}
                                onChange={(event) => this.controller.setCNPJDestinatarioSemPensar(event.target.value, this.props.dado, this.props.setDadoDireto)}
                                //onBlur={ this.handleMudaCnpjDestinatario } 
                            />}
                            {this.controller.atualizaBagagem && this.controller.atualizarCnpjDest && 
                            <FormInput titulo="Razão Social" sm={12} md={4}
                                objeto={ this.props.ntFiscal }
                                dado={ `Nf.RazaoSocialDest` }
                                limiteMaximo={80}
                                //alerta={ (this.props.salvo && !_.get(this.props.ntFiscal, "Nf.RazaoSocialDest")) ? "Campo obrigatório" : "" }
                                onChange={ (event) => this.props.setDado(`${this.props.dado}.Nf.RazaoSocialDest`, event) } 
                            />}
                            {this.controller.atualizaBagagem &&
                            <FormInput titulo="Inscrição" sm={12} md={4}
                                objeto={ this.props.ntFiscal }
                                dado={ `Nf.InscrEstadDest` }
                                onChange={ (event) => this.props.setDado(`${this.props.dado}.Nf.InscrEstadDest`, event) } />
                            }
                            {this.controller.atualizaBagagem &&
                            <FormSelect titulo="País" sm={12} md={4}
                                itens={ this.controller.paises }
                                objeto={ this.props.ntFiscal }
                                dado={ "Nf.CdPaisDest" }
                                itensValor="Id" itensLabel="Texto"
                                naoLimpar={true}
                                //alerta={ (this.props.salvo && !_.get(this.props.ntFiscal, "Nf.CdPaisDest")) ? "Campo obrigatório" : "" }
                                onChange={event => { 
                                    this.props.setDado(`${this.props.dado}.Nf.CdPaisDest`, event);
                                    this.controller.setPais(event, this.props.dado, this.props.setDado); }}/>
                            }
                            {this.controller.atualizaBagagem && (this.controller.paisSelecionado && _.get(this.props.ntFiscal, "Nf.CdPaisDest"))
                            && <FormSelect titulo="UF" sm={12} md={4}
                                    itens={ this.controller.UFs }
                                    objeto={ this.props.ntFiscal }
                                    dado={ "Nf.CdUnidadeFedDest" }
                                    itensValor="Id" itensLabel="Texto"
                                    onChange={ (event) => this.props.setDado(`${this.props.dado}.Nf.CdUnidadeFedDest`, event) } 
                                />
                            }
                            {this.controller.atualizaBagagem && (this.controller.paisSelecionado && _.get(this.props.ntFiscal, "Nf.CdPaisDest"))
                            && <FormInput titulo="Cidade" sm={12} md={4}
                                    objeto={ this.props.ntFiscal }
                                    dado={ `Nf.NomCidadeDest` }
                                    //alerta={ (this.props.salvo && !_.get(this.props.ntFiscal, "Nf.NomCidadeDest")) ? "Campo obrigatório" : "" }
                                    onChange={ (event) => this.props.setDado(`${this.props.dado}.Nf.NomCidadeDest`, event) } 
                                />
                            }
                        </Row>
                        { this.props.atualizaDados ? this.listaContainers() : <div /> }
                        { this.props.atualizaDados ? this.listaNCMs() : <div /> }
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div>
                { !this.state.atualizado ? this.excluiDadosNota() : this.listaNotaFiscalForm() }
            </div>
        );
    	
    }
}



// WEBPACK FOOTER //
// ./src/modules/agendamento/containers-cadastrar/entrada-containers/components/CardNotaFiscal.js